<template>
  <div>
    <div class="top-box">
      <a-input v-model:value="searchValue" style="margin-bottom: 8px" :placeholder="t('system.2wy1yg')" />
      <!-- <img src="@/assets/tree/editbtn.svg" alt="" @click="handleEdit" /> -->
      <a-button
        :class="{ 'no-border': showEdit }"
        @click="handleEdit"
        class="btn-edit"
        v-permission="'base_applyservice_edit_btn'"
      >
        <template #icon>
          <img src="@/assets/marketing/edit.svg" v-if="!showEdit" />
          <span class="iconfont icon-baocuo" v-else />
        </template>
      </a-button>
    </div>
    <a-tree
      v-bind="$attrs"
      v-model:selectedKeys="selectedKeys"
      :showIcon="false"
      :checkable="false"
      :tree-data="treeDataComputed"
      @select="onCheck"
      :autoExpandParent="autoExpandParent"
      :expanded-keys="expandedKeys"
      @expand="onExpand"
    >
      <template #title="{ dataRef, name }">
        <slot name="title" v-if="dataRef.type && dataRef.type == 'add'">
          <div style="height: 150px" @click.stop="addNewService(dataRef)">
            <div class="add-or-delete-box" :class="[dataRef.key == newClassKey ? 'select-add' : '']">
              <plus-circle-outlined :class="[dataRef.key == newClassKey ? 'select-img' : '']" />
              <p>{{ t('btn.add') }}</p>
            </div>
          </div>
        </slot>
        <slot name="title" v-else>
          <div :class="[dataRef.children && dataRef.children.length ? 'has-tree-child' : 'no-tree-child']">
            <span
              v-if="name && name.indexOf(searchValue) > -1"
              :style="{ color: dataRef.status === 1 ? '#ccc' : '#132043d9' }"
            >
              {{ name.substr(0, name.indexOf(searchValue)) }}
              <span style="color: #f50">{{ searchValue }}</span>
              {{ name.substr(name.indexOf(searchValue) + searchValue.length) }}
            </span>
            <span v-else>{{ name }}</span>

            <!-- <minus-circle-outlined @click.stop="" class="delete-btn" v-if="showEdit" @click="handleDelete(dataRef)" /> -->
          </div>
        </slot>
      </template>
    </a-tree>
    <div
      class="add-or-delete-box"
      style="margin-top: 10px"
      v-if="showEdit"
      @click="handleParentAdd"
      :class="[-1 === newClassKey ? 'select-add' : '']"
    >
      <plus-circle-outlined :class="[-1 === newClassKey ? 'select-img' : '']" />
      <p>{{ t('btn.add') }}</p>
    </div>
  </div>
</template>
<script lang="ts" setup>
import type { TreeProps } from 'ant-design-vue'
import { ref, watch } from 'vue'
import type { PropType } from 'vue'
import { PlusCircleOutlined } from '@ant-design/icons-vue'
// import { DcConfirm, DcMessage } from '@dc-platform/dc-components'
// import { SaveServiceParamParams } from '@/typings/api/systemSetting'
// import { deleteServiceParam } from '@/api/systemSetting/index'
import type { EventDataNode, DataNode } from 'ant-design-vue/es/tree'
import changeAddBtn from '../hooks/changeBtnToTree'
import addBackgroundClass from '../hooks/addBackgroundClass'
import { useI18n } from 'vue-i18n'
const { t } = useI18n()

const props = defineProps({
  treeData: {
    type: Array as PropType<TreeProps['treeData']>,
    default: () => []
  },
  dataSource: {
    type: Array,
    default: () => []
  },
  searchData: {
    type: Object,
    default: () => {
      return {}
    }
  },
  checkable: {
    type: Boolean,
    default: true
  },
  checkedKeys: {
    type: Array as PropType<string[]>,
    default: () => []
  }
})
const emit = defineEmits(['selectTreeData', 'emptyTreeData', 'addNewService', 'successRefresh', 'showEditEmit'])

const selectedKeys = ref<string[]>([])
const treeDataComputed = ref()
const nowExpandIdArr = ref([])
watch(
  () => props.treeData,
  (val) => {
    treeDataComputed.value = val
    isExpandAddClass(nowExpandIdArr.value, treeDataComputed.value)
    if (showEdit.value) {
      showAddBtn(treeDataComputed.value)
    }
  }
)
// 列选中

// 复选框选中
const onCheck = (
  checkedKey: any,
  info: { event: 'select'; selected: boolean; node: EventDataNode; selectedNodes: DataNode[]; nativeEvent: MouseEvent }
) => {
  if (checkedKey.length > 0) {
    emit('selectTreeData', info.node.id)
  } else {
    emit('emptyTreeData')
  }
  // 整合checkedKeys
}

// 搜索
const searchValue = ref<string>('')
const expandedKeys = ref<(string | number)[]>([])
const autoExpandParent = ref<boolean>(true)
const gData = ref<TreeProps['treeData']>()
// 添加背景色class
const { isExpandAddClass, removeExpandClass } = addBackgroundClass()

const onExpand = (keys: any) => {
  nowExpandIdArr.value = keys
  isExpandAddClass(keys, treeDataComputed.value)
  removeExpandClass(keys, treeDataComputed.value)
  expandedKeys.value = keys
  autoExpandParent.value = false
}
const dataList: TreeProps['treeData'] = []
const generateList = (data: TreeProps['treeData']) => {
  if (data) {
    for (let i = 0; i < data.length; i++) {
      const node = data[i]
      const key = node.key
      dataList.push({ key, name: node.name })
      if (node.children) {
        generateList(node.children)
      }
    }
  }
}
watch(props, () => {
  generateList(treeDataComputed.value)
  gData.value = props.treeData
})

const getParentKey = (key: string | number, tree: TreeProps['treeData']): string | number | undefined => {
  let parentKey
  if (tree) {
    for (let i = 0; i < tree.length; i++) {
      const node = tree[i]
      if (node.children) {
        if (node.children.some((item) => item.key === key)) {
          parentKey = node.key
        } else if (getParentKey(key, node.children)) {
          parentKey = getParentKey(key, node.children)
        }
      }
    }
  }

  return parentKey
}
watch(searchValue, (value) => {
  if (!searchValue.value) {
    autoExpandParent.value = false
    return
  }

  const expanded: any = dataList
    .map((item) => {
      if (item.name && item.name.indexOf(value) > -1) {
        return getParentKey(item.key, gData.value)
      }
      return null
    })
    .filter((item, i, self) => item && self.indexOf(item) === i)
  nowExpandIdArr.value = expanded
  if (expanded) {
    const arr: any = []
    expanded.forEach((item: string | number) => {
      if (getParentKey(item, gData.value)) {
        arr.push(getParentKey(item, gData.value))
      }
    })
    isExpandAddClass(expanded, treeDataComputed.value)
    console.log('expanded: ', expanded)

    removeExpandClass(expanded, treeDataComputed.value)
    console.log('treeDataComputed.value: ', treeDataComputed.value)
    expandedKeys.value = expanded
  }
  searchValue.value = value
  autoExpandParent.value = true
})
// 第一层新增
const handleParentAdd = () => {
  if (newClassKey.value === -1) {
    newClassKey.value = ''
    selectedKeys.value = []
    emit('emptyTreeData')
  } else {
    newClassKey.value = -1
    selectedKeys.value = []
    emit('addNewService', { data: { id: -1 } })
  }
}
// 新增
const newClassKey = ref()
watch(selectedKeys, () => {
  if (selectedKeys.value.length > 0) {
    newClassKey.value = null
  }
})
const addNewService = (dataRef: any) => {
  console.log('dataRef: ', dataRef)
  if (newClassKey.value === dataRef.key) {
    newClassKey.value = ''
    selectedKeys.value = []
    emit('emptyTreeData')
  } else {
    newClassKey.value = dataRef.key
    selectedKeys.value = []
    emit('addNewService', dataRef)
  }
}
// 编辑
const showEdit = ref<boolean>(false)
const { showAddBtn, removeAddBtn } = changeAddBtn()

const handleEdit = () => {
  if (showEdit.value) {
    treeDataComputed.value = removeAddBtn(treeDataComputed.value)
    cleanFirstLevelClass(treeDataComputed.value)
    showEdit.value = false
    emit('showEditEmit', showEdit.value)
    // DcConfirm.warning({
    //   title: '操作提示！',
    //   content: '信息更改还没有保存，确认是否离开',
    //   cancelText: '取消',
    //   okText: '继续',
    //   onOk: () => {
    //     treeDataComputed.value = removeAddBtn(treeDataComputed.value)
    //     cleanFirstLevelClass(treeDataComputed.value)
    //     showEdit.value = false
    //     emit('showEditEmit', showEdit.value)
    //   }
    // })
  } else {
    showEdit.value = false
    showAddBtn(treeDataComputed.value)
    showEdit.value = true
  }
  emit('showEditEmit', showEdit.value)
}
// 去除第一层级（且没有children）的数据的背景颜色class
const cleanFirstLevelClass = (arr: any) => {
  arr.forEach((item: any) => {
    if (item.children.length === 0 && item.parentId === -1) {
      item.class = ''
    }
  })
}
// 删除
// const handleDelete = async (dataRef: SaveServiceParamParams) => {
//   DcConfirm.warning({
//     title: '操作提示！',
//     content: '本操作不可恢复，请谨慎操作！',
//     cancelText: '取消',
//     okText: '确认',
//     onOk: () => {
//       deleteMethod(dataRef)
//       // try {
//       //   console.log(dataRef)
//       // } catch (error) {
//       //   console.log('handleDelete error: ', error)
//       // }
//     }
//   })
// }
// const deleteMethod = async (dataRef: SaveServiceParamParams) => {
//   try {
//     await deleteServiceParam({
//       paramId: dataRef.id
//     })
//     emit('successRefresh')
//     DcMessage.success('删除成功！')
//   } catch (error) {
//     console.log('deleteMethod error: ', error)
//   }
// }
</script>
<style lang="scss">
.check {
  position: absolute;
}
.top-radios {
  height: 40px;
  width: 40px;
  background: #1d4cd2;
  display: block;
}
.tree-content {
  padding-bottom: 8px;
  border-radius: 4px;
  position: relative;
  &::after {
    content: ' ';
    position: absolute;
    height: 1px;
    transform: scaleY(0.5);
    -webkit-transform: scaleY(0.5); /*兼容-webkit-引擎浏览器*/
    -moz-transform: scaleY(0.5);
    border-bottom: 1px solid #d8dfe4;
    right: 0;
    left: 12px;
    bottom: 8px;
  }
}
.ant-tree .ant-tree-treenode {
  width: 100%;
  padding: 0 !important;
}
.ant-tree-treenode {
  height: 36px;
}
.ant-tree-treenode-selected {
  .active-tree-node {
    display: block;
  }
}
.active-tree-node {
  background-color: #1d4cd2;
  position: absolute;
  left: 4px;
  right: 4px;
  top: 1px;
  bottom: 2px;
  padding-left: 10px;
  color: #fff;
  display: none;
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
}
.check-tree {
  background: #f3f5f7;
  .ant-tree {
    background: transparent;
  }
}
.ant-tree-switcher,
.ant-tree-node-content-wrapper {
  height: 36px;
  line-height: 36px !important;
}
.ant-tree .ant-tree-node-content-wrapper {
  height: 36px;
  line-height: 36px;
  border-radius: 0;
  width: 287px;
}
.ant-tree-indent-unit {
  height: 100%;
}
.ant-tree-indent-unit-end,
.ant-tree-indent-unit-start {
  height: 100%;
}
// .ant-tree-switcher-noop {
//   display: none;
// }
// 多选框
.ant-tree-checkbox {
  top: 13px;
  margin: 0;
  padding: 0 4px 0 4px;
}
.ant-tree-checkbox-inner {
  width: 14px;
  height: 14px;
}
// 画线
.no-tree-child,
.has-tree-child {
  border-bottom: 1px solid rgb(226, 231, 236);
  height: 35px;
  &::after {
    content: ' ';
    position: absolute;
    height: 1px;
    right: 0;
    bottom: 0;
    transform: scaleY(0.5);
    -webkit-transform: scaleY(0.5); /*兼容-webkit-引擎浏览器*/
    -moz-transform: scaleY(0.5);
    border-bottom: 1px solid #d8dfe4;
  }
}
.multiple-table {
  .no-tree-child {
    &::after {
      left: -34px;
    }
  }
  .has-tree-child {
    &::after {
      content: ' ';
      left: -58px;
    }
  }
  .ant-tree .ant-tree-treenode:first-child {
    .has-tree-child {
      &::after {
        left: -46px;
      }
    }
  }
}
.single-tree {
  .no-tree-child {
    &::after {
      left: -12px;
    }
  }
  .has-tree-child {
    &::after {
      left: -36px;
    }
  }
  .ant-tree .ant-tree-treenode:first-child {
    .has-tree-child {
      &::after {
        left: -24px;
      }
    }
  }
}
.ant-tree-indent-unit-start,
.ant-tree-indent-unit {
  position: relative;
  &::after {
    content: ' ';
    position: absolute;
    height: 100%;
    width: 1px;
    left: 50%;
    top: 0;
    border-left: 1px solid #d8dfe4;
    transform: scaleX(0.5);
    -webkit-transform: scaleX(0.5); /*兼容-webkit-引擎浏览器*/
    -moz-transform: scaleX(0.5);
  }
}
// 选中样式
.ant-tree-treenode-selected {
  background: #1d4cd2 !important;
  color: #fff;
  .no-tree-child,
  .has-tree-child {
    border-bottom: none !important;
  }
  .ant-tree-indent {
    background: #f3f5f7;
    position: relative;
    &::before {
      content: ' ';
      //   background: url(http://10.81.5.105:10200/img/subtract.a5b882a8.svg);
      height: 4px;
      width: 4px;
      position: absolute;
      right: -4px;
    }
    &::after {
      content: ' ';
      //   background: url(http://10.81.5.105:10200/img/subtract.a5b882a8.svg);
      height: 4px;
      width: 4px;
      position: absolute;
      right: -4px;
      bottom: 0;
      transform: rotate(270deg);
    }
  }
}
.ant-tree .ant-tree-node-content-wrapper.ant-tree-node-selected {
  background: #1d4cd2 !important;
  span {
    color: #fff !important;
  }
}
// hover
.ant-tree .ant-tree-node-content-wrapper {
  &:hover {
    background-color: transparent;
  }
}
.add-or-delete-box {
  width: 100%;
  height: 30px;
  border: 1px dashed #ccc;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 6px;
  cursor: pointer;
  p {
    margin-left: 10px;
    margin-bottom: 0 !important;
  }
}
.select-add {
  background-color: #1d4cd2;
  p {
    color: #fff;
  }
  .select-img {
    color: #fff;
  }
}
.top-box {
  display: flex;
  justify-content: space-between;
  align-items: center;
  .btn-edit {
    margin: 0 0 8px 12px;
    display: flex;
    justify-content: center;
    align-items: center;
    .iconfont {
      margin-right: 0 !important;
    }
  }
  // img {
  //   display: block;
  //   margin: 0 0 8px 8px;
  //   cursor: pointer;
  // }
}
.delete-btn {
  position: absolute;
  right: 10px;
  top: 10px;
}
.isExpendBg {
  background: #f3f5f7;
}
.parentIdNotFirst {
  width: 50px;
}
.tree-box .ant-tree {
  overflow: hidden !important;
}
.ant-tree .ant-tree-node-content-wrapper {
  flex: 1;
  overflow: hidden;
  .has-tree-child > span:nth-of-type(1) {
    width: 90%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    display: block;
  }
}
</style>
